<script setup>
import { ref, computed } from 'vue'
import ExclamationIcon from '@svgs/exclamation-icon-circle.svg'

const props = defineProps({
	errors: Object,
})

const filteredErrors = computed(() => {
	return Object.keys(props.errors)
		.filter( value => value !== 'arrive_time')
  	.map( value => value.replace('_', ' '))
})

const isOrAre = computed(() => {
	return filteredErrors.value.length > 1 ? 'are' : 'is'
})

const errorsString = computed(() => {
	const allErrors = [...filteredErrors.value]
	const lastError = allErrors.pop()
  return allErrors.join(', ')
  	+ (allErrors.length ? ' and ' : '')
  	+ lastError
})

</script>

<template>
	<div v-if="filteredErrors.length" class="flex items-center bg-red text-white p-2 px-4">
		<ExclamationIcon class="mr-2" />
		<p>{{ errorsString }} {{ isOrAre }} required</p>
	</div>
</template>

<style scoped>
p::first-letter {
  text-transform: capitalize;
}
</style>
